var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShape = function SvgShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 18.5a4 4 0 0 1-4 4H6.157a4 4 0 0 1-2.829-1.172l-1.656-1.656A4 4 0 0 1 .5 16.843V4.5a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v14Zm-16-3v-11a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7v-2a3 3 0 0 0-3-3h-2Zm.11 2a2 2 0 0 0 .476.757l1.657 1.657a2 2 0 0 0 .757.475V18.5a1 1 0 0 0-1-1H2.61Z",
    fill: "#B1B5C4"
  })));
};
export default SvgShape;